import Router from "./Router";
// import ReactRouter from "./pages/chapter11/ReactRouter";
// import RouterQuiz from "./pages/chapter11/RouterQuiz";

function App() {
  return <Router />;
}
export default App;
